'use client';

import { modalSelector } from '@findy-code/yuffie/store';
import { useSelector } from 'react-redux';

export const ModalManager = () => {
  const { modalComponent, modalProps } = useSelector(modalSelector);

  if (!modalComponent) return null;

  const ModalComponent = modalComponent;
  return <ModalComponent {...modalProps} />;
};
